import { DropdownPrimeReact } from "@finanedi.es/storybook"
import { DireccionEmpresaGetUsuarioLoggedDtoProps } from "api/DTOs/DireccionEmpresaGetUsuarioLoggedDto"

const generarDireccion = (
  objeto: DireccionEmpresaGetUsuarioLoggedDtoProps & {
    poblacionNombre?: string
    provinciaNombre?: string
  }
) => {
  const {
    calle,
    codigoPostal,
    poblacion,
    provincia,
    poblacionNombre,
    provinciaNombre,
  } = objeto

  if (poblacion) {
    let direccion = `${calle || ""}${calle && codigoPostal ? ", " : ""}${
      codigoPostal || ""
    }${codigoPostal && poblacion?.nombre ? ", " : ""}${poblacion?.nombre || ""}`
    if (provincia?.nombre) {
      direccion += ` (${provincia?.nombre})`
    }
    return direccion
  }
  let direccion = `${calle || ""}${calle && codigoPostal ? ", " : ""}${
    codigoPostal || ""
  }${codigoPostal && poblacionNombre ? ", " : ""}${poblacionNombre || ""}`
  if (provinciaNombre) {
    direccion += ` (${provinciaNombre})`
  }

  return direccion
}

const CardContactDocumento = ({
  isLibrado = false,
  data,
  setFieldValue,
}: {
  isLibrado?: boolean
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: $TSMigrationFixMe
  setFieldValue: (
    field: string,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    value: $TSMigrationFixMe,
    shouldValidate?: boolean
  ) => Promise<void>
}) => {
  return (
    <div className=' tw-w-full tw-flex tw-flex-col tw-pb-1.5 tw-text-left'>
      <p className='tw-mt-4 tw-text-xl tw-mb-0 tw-p-2 tw-w-full tw-truncate tw-font-medium'>
        {data?.razonSocial}
      </p>
      {(data?.nif || data?.cif) && (
        <p className='tw-p-2 tw-w-full tw-mb-0 tw-truncate'>
          {data?.nif ?? data?.cif}
        </p>
      )}
      {data?.direccion && (
        <p className='tw-w-full tw-mb-0 tw-truncate tw-p-2 tw-text-wrap'>
          {generarDireccion(data?.direccion)}
        </p>
      )}
      {data?.emails?.length > 1 ? (
        <DropdownPrimeReact
          onChange={({ value }: { value: string }) =>
            setFieldValue(isLibrado ? "librado.email" : "librador.email", value)
          }
          value={data?.email}
          options={data?.emails}
          optionValue='contacto'
          optionLabel='contacto'
          className='!tw-w-fit !tw-border-none !tw-bg-transparent'
        />
      ) : (
        <p className='tw-mb-0 tw-p-2 tw-w-full tw-truncate'>
          {data?.email ?? data?.emails?.[0]?.contacto}
        </p>
      )}
      {data?.telefonos?.length > 1 ? (
        <DropdownPrimeReact
          onChange={({ value }: { value: string }) => {
            setFieldValue(
              isLibrado ? "librado.telefono" : "librador.telefono",
              value
            )
          }}
          className='!tw-w-fit !tw-border-none !tw-bg-transparent'
          value={data?.telefono}
          options={data?.telefonos}
          optionValue='contacto'
          optionLabel='contacto'
        />
      ) : (
        <p className='tw-p-2 tw-mb-0 tw-w-full tw-truncate'>{data?.telefono}</p>
      )}
    </div>
  )
}

export default CardContactDocumento
